
                import { Component } from "/app/packages/open-source/blognami/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/open-source/blognami/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/open-source/blognami/lib/views/_blognami/_form.js";
                const hash = "4RWjaCK1JI";
                Component.include(createDecoratorsInclude(hash, decorators));
            